import { getMimeTypeFromExtension } from '../../../../utils';
import angular from 'angular';
export default class ListaRelatorioService {
    $q;
    $http;
    CoreListaNorma;
    CoreListaRelatorio;
    CoreListaRelatorioParametro;
    CoreListaRelatorioParametroPonto;
    CoreListaRelatorioEnsaio;
    CoreListaRelatorioEnsaioPonto;
    CoreListaRelatorioEquipamento;
    CoreListaRelatorioEquipamentoPonto;
    CoreListaRelatorioFicheiro;
    CoreListaRelatorioResultado;
    CoreListaRelatorioResposta;
    CoreListaRelatorioValidacao;
    CoreListaRelatorioDefeitoTipo;
    CoreListaRelatorioMotivo;
    CoreDepartamento;
    CoreFormaPagamento;
    user;
    constructor($q, $http, AuthenticationService, CoreListaNorma, CoreListaRelatorio, CoreListaRelatorioParametro, CoreListaRelatorioParametroPonto, CoreListaRelatorioEnsaio, CoreListaRelatorioEnsaioPonto, CoreListaRelatorioEquipamento, CoreListaRelatorioEquipamentoPonto, CoreListaRelatorioFicheiro, CoreListaRelatorioResultado, CoreListaRelatorioResposta, CoreListaRelatorioValidacao, CoreListaRelatorioDefeitoTipo, CoreListaRelatorioMotivo, CoreDepartamento, CoreFormaPagamento) {
        this.$q = $q;
        this.$http = $http;
        this.CoreListaNorma = CoreListaNorma;
        this.CoreListaRelatorio = CoreListaRelatorio;
        this.CoreListaRelatorioParametro = CoreListaRelatorioParametro;
        this.CoreListaRelatorioParametroPonto = CoreListaRelatorioParametroPonto;
        this.CoreListaRelatorioEnsaio = CoreListaRelatorioEnsaio;
        this.CoreListaRelatorioEnsaioPonto = CoreListaRelatorioEnsaioPonto;
        this.CoreListaRelatorioEquipamento = CoreListaRelatorioEquipamento;
        this.CoreListaRelatorioEquipamentoPonto = CoreListaRelatorioEquipamentoPonto;
        this.CoreListaRelatorioFicheiro = CoreListaRelatorioFicheiro;
        this.CoreListaRelatorioResultado = CoreListaRelatorioResultado;
        this.CoreListaRelatorioResposta = CoreListaRelatorioResposta;
        this.CoreListaRelatorioValidacao = CoreListaRelatorioValidacao;
        this.CoreListaRelatorioDefeitoTipo = CoreListaRelatorioDefeitoTipo;
        this.CoreListaRelatorioMotivo = CoreListaRelatorioMotivo;
        this.CoreDepartamento = CoreDepartamento;
        this.CoreFormaPagamento = CoreFormaPagamento;
        this.user = AuthenticationService.getUser();
    }
    getUserId() {
        return this.user.id;
    }
    getFormasPagamento() {
        return this.CoreFormaPagamento.find({ filter: { where: { active: true } } }).$promise;
    }
    getFileDetails(main, folder, path) {
        return this.$http.get(`/api/${main}/${folder}/files/${path}`);
    }
    getType(path) {
        return getMimeTypeFromExtension(path);
    }
    uploadTemplate(main, folder, file) {
        const formData = new FormData();
        formData.append('file', file);
        return this.$http.post(`/api/${main}/${folder}/upload`, formData, {
            transformRequest: angular.identity,
            headers: { 'Content-Type': undefined }
        });
    }
    postFicheiro(data) {
        return this.CoreListaRelatorioFicheiro.create(data).$promise;
    }
    patchFicheiro(id, data) {
        return this.CoreListaRelatorioFicheiro.patch({ id: id }, data).$promise;
    }
    postValidacao(data) {
        return this.CoreListaRelatorioValidacao.create(data).$promise;
    }
    patchValidacao(id, data) {
        return this.CoreListaRelatorioValidacao.patch({ id: id }, data).$promise;
    }
    clone(id) {
        return this.CoreListaRelatorio.clone({ id }).$promise;
    }
    getUploadFolder(departamentoId) {
        let defer = this.$q.defer();
        this.CoreDepartamento.findById({ id: departamentoId })
            .$promise.then(r => {
            defer.resolve(r.designacao
                .toLowerCase()
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, ''));
        })
            .catch(e => defer.reject(e));
        return defer.promise;
    }
    findDepartamentos() {
        return this.CoreDepartamento.find({
            filter: {
                where: {
                    active: 1
                }
            }
        }).$promise;
    }
    findAll(query) {
        return this.CoreListaRelatorio.table(query).$promise;
    }
    options() {
        return this.CoreListaRelatorio.options().$promise;
    }
    create(data) {
        return this.CoreListaRelatorio.create(data).$promise;
    }
    patch(id, data) {
        return this.CoreListaRelatorio.patch({ id }, data).$promise;
    }
    publish(id) {
        return this.CoreListaRelatorio.publish({ id }).$promise;
    }
    findOne(id) {
        return this.CoreListaRelatorio.findOne({
            filter: {
                where: {
                    id
                },
                include: ['Funcionario', 'Departamento', 'Parametros', 'Ensaios', 'Equipamentos', 'Norma', 'Ficheiros', 'Validacoes']
            }
        }).$promise;
    }
    findAvailableNormas() {
        let defer = this.$q.defer();
        this.CoreListaNorma.find({
            filter: {
                where: {
                    active: true
                },
                include: {
                    relation: 'Listas',
                    scope: {
                        limit: 1,
                        where: {
                            active: true
                        }
                    }
                }
            }
        })
            .$promise.then(r => {
            let a = r.filter(n => !n.Listas.length);
            defer.resolve(a);
        })
            .catch(e => defer.reject(e));
        return defer.promise;
    }
    findResultados(departamento) {
        return this.CoreListaRelatorioResultado.find({
            filter: {
                where: {
                    coreDepartamentoId: departamento
                }
            }
        }).$promise;
    }
    findParametro(id) {
        return this.CoreListaRelatorioParametro.findOne({
            filter: {
                where: {
                    id
                },
                include: ['Pontos', 'CoreListaRelatorio']
            }
        }).$promise;
    }
    findEnsaio(id) {
        return this.CoreListaRelatorioEnsaio.findOne({
            filter: {
                where: {
                    id
                },
                include: ['Pontos', 'CoreListaRelatorio']
            }
        }).$promise;
    }
    findEquipamento(id) {
        return this.CoreListaRelatorioEquipamento.findOne({
            filter: {
                where: {
                    id
                },
                include: ['Pontos', 'CoreListaRelatorio']
            }
        }).$promise;
    }
    //TODO asdad
    findEnsaiosOfList(id) {
        let defer = this.$q.defer();
        return this.CoreListaRelatorioEnsaio.find({
            filter: {
                where: {
                    coreListaRelatorioId: id,
                    active: 1
                },
                include: 'Pontos'
            }
        }).$promise;
    }
    findDefeitosByTipo(coreDepartamentoId) {
        return this.CoreListaRelatorioDefeitoTipo.find({
            filter: {
                where: {
                    coreDepartamentoId,
                    active: 1
                },
                include: {
                    relation: 'Defeitos',
                    scope: {
                        where: {
                            active: true
                        }
                    }
                }
            }
        }).$promise;
    }
    getMotivos() {
        // adicionar se user for admin vai buscar todos, se não for vai buscar com o campo admin = 0
        return this.CoreListaRelatorioMotivo.find({
            filter: {
                where: {
                    active: 1
                }
            }
        }).$promise;
    }
    getCoreListaRelatorioResposta(id) {
        return this.CoreListaRelatorioResposta.findOne({
            filter: {
                where: {
                    id
                },
                include: [
                    {
                        relation: 'Ficheiros',
                        scope: {
                            where: {
                                active: 1
                            },
                            include: 'RelatorioFicheiro'
                        }
                    },
                    {
                        relation: 'CoreListaRelatorio',
                        scope: {
                            include: [
                                'Funcionario',
                                {
                                    relation: 'Departamento',
                                    scope: {
                                        include: 'Responsavel'
                                    }
                                },
                                {
                                    relation: 'Parametros',
                                    scope: {
                                        where: {
                                            active: 1
                                        },
                                        order: 'ordem ASC',
                                        include: {
                                            relation: 'Pontos',
                                            scope: {
                                                where: {
                                                    active: 1
                                                },
                                                order: 'ordem ASC'
                                            }
                                        }
                                    }
                                },
                                {
                                    relation: 'Ensaios',
                                    scope: {
                                        where: {
                                            active: 1
                                        },
                                        order: 'ordem ASC',
                                        include: {
                                            relation: 'Pontos',
                                            scope: {
                                                where: {
                                                    active: 1
                                                },
                                                order: 'ordem ASC'
                                            }
                                        }
                                    }
                                },
                                {
                                    relation: 'Equipamentos',
                                    scope: {
                                        where: {
                                            active: 1
                                        },
                                        order: 'ordem ASC',
                                        include: {
                                            relation: 'Pontos',
                                            scope: {
                                                where: {
                                                    active: 1
                                                },
                                                order: 'ordem ASC'
                                            }
                                        }
                                    }
                                },
                                'Norma'
                            ]
                        }
                    },
                    'CoreListaRelatorioResultado',
                    'ValidadoPor',
                    'Tecnico'
                ]
            }
        }).$promise;
    }
    calcularResposta(id) {
        // structureData
        return this.CoreListaRelatorioResposta.complete({ id: id });
    }
    saveDataSubmissao(data, dataSubmissao) {
        data.dataSubmissao = dataSubmissao;
        return this.CoreListaRelatorioResposta.upsert(data).$promise;
    }
    saveResposta(resposta) {
        return this.CoreListaRelatorioResposta.patch(resposta).$promise;
    }
    validateResposta(id) {
        return this.CoreListaRelatorioResposta.validate({
            id
        }).$promise;
    }
    cloneResposta(id) {
        return this.CoreListaRelatorioResposta.clone({
            id
        }).$promise;
    }
    createParametro(data) {
        return this.CoreListaRelatorioParametro.create(data).$promise;
    }
    saveParametro(id, data) {
        return this.CoreListaRelatorioParametro.patch({ id }, data).$promise;
    }
    saveParametroPonto(data) {
        return this.CoreListaRelatorioParametroPonto.upsert(data).$promise;
    }
    createEnsaio(data) {
        return this.CoreListaRelatorioEnsaio.create(data).$promise;
    }
    saveEnsaio(id, data) {
        return this.CoreListaRelatorioEnsaio.patch({ id }, data).$promise;
    }
    saveEnsaioPonto(data) {
        return this.CoreListaRelatorioEnsaioPonto.upsert(data).$promise;
    }
    createEquipamento(data) {
        return this.CoreListaRelatorioEquipamento.create(data).$promise;
    }
    saveEquipamento(id, data) {
        return this.CoreListaRelatorioEquipamento.patch({ id }, data).$promise;
    }
    saveEquipamentoPonto(data) {
        return this.CoreListaRelatorioEquipamentoPonto.upsert(data).$promise;
    }
}
ListaRelatorioService.$inject = [
    '$q',
    '$http',
    'AuthenticationService',
    'CoreListaNorma',
    'CoreListaRelatorio',
    'CoreListaRelatorioParametro',
    'CoreListaRelatorioParametroPonto',
    'CoreListaRelatorioEnsaio',
    'CoreListaRelatorioEnsaioPonto',
    'CoreListaRelatorioEquipamento',
    'CoreListaRelatorioEquipamentoPonto',
    'CoreListaRelatorioFicheiro',
    'CoreListaRelatorioResultado',
    'CoreListaRelatorioResposta',
    'CoreListaRelatorioValidacao',
    'CoreListaRelatorioDefeitoTipo',
    'CoreListaRelatorioMotivo',
    'CoreDepartamento',
    'CoreFormaPagamento'
];
